/** Day column header with date label. */
import { format } from 'date-fns';
import { Box } from '@mui/material';

const DayColumnHeader = ({ day }) => (
  <Box
    className="shared-day-header"
    data-testid="day-column-header"
    sx={{
      position: 'sticky',
      top: 0,
      zIndex: 11,
      height: 'var(--plan-day-header-height)',
      boxSizing: 'border-box',
      px: '10px',
      bgcolor: 'background.subtle',
      borderBottom: 1,
      borderColor: 'divider',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      fontWeight: 700,
      fontSize: '0.95em',
      flexShrink: 0,
    }}
  >
    <span>{day.label ? day.label : format(day.date, 'EEEE dd/MM')}</span>
  </Box>
);

export default DayColumnHeader;
